/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import NavBar from './NavBar';
import Card from './Card';

class OpenOnMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = { foo: 'bar' };
  }

  render() {
    return (
      <div>
        <NavBar />
        <div className="h-14" />
        <Card className="flex items-center justify-center p-4">
          <h2 className="text-xl font-semibold">
            Open Link on your mobile device!
          </h2>
        </Card>
      </div>
    );
  }
}

export default OpenOnMobile;
